// アプリケーションの状態管理
export let albumImages = [null, null, null, null];
export let allTemplates = [];
export let selectedTemplateId = null;
export let currentSelectedTemplate = null;

// 画像の変換情報を管理する配列
export let imageTransforms = [
  { scale: 1, rotation: 0, offsetX: 0, offsetY: 0 },
  { scale: 1, rotation: 0, offsetX: 0, offsetY: 0 },
  { scale: 1, rotation: 0, offsetX: 0, offsetY: 0 },
  { scale: 1, rotation: 0, offsetX: 0, offsetY: 0 },
];

// アルバムプレビューモーダル開始時の状態を保存する変数
export let albumPreviewBackupTransforms = null;

// 編集中の画像インデックスと一時的な変換情報
export let editingImageIndex = null;
export let tempTransform = null;
export let editingImage = null; // 編集中の画像オブジェクトを保存

// テキスト入力値を管理
export let textValues = {
  studentName: "",
  department: "",
  course: "",
  title: "",
  message: "",
};

// レイアウト情報とテキスト管理
export let layoutData = null;
export let currentPageSize = "A4"; // デフォルトはA4

// 状態更新関数
export const updateAlbumImage = (index, imageData) => {
  if (index >= 0 && index < albumImages.length) {
    albumImages[index] = imageData;
  }
};

export const updateAllTemplates = (templates) => {
  allTemplates = templates;
};

export const updateSelectedTemplate = (templateId) => {
  selectedTemplateId = templateId;
  currentSelectedTemplate = allTemplates.find((t) => t.templateId === templateId);
};

export const updateImageTransform = (index, transform) => {
  if (index >= 0 && index < imageTransforms.length) {
    imageTransforms[index] = { ...transform };
  }
};

export const updateImageTransforms = (transforms) => {
  imageTransforms = transforms.map((transform) => ({ ...transform }));
};

export const setAlbumPreviewBackupTransforms = (transforms) => {
  albumPreviewBackupTransforms = transforms ? transforms.map((transform) => ({ ...transform })) : null;
};

export const setEditingState = (imageIndex, transform, image) => {
  editingImageIndex = imageIndex;
  tempTransform = transform ? { ...transform } : null;
  editingImage = image;
};

export const clearEditingState = () => {
  editingImageIndex = null;
  tempTransform = null;
  editingImage = null;
};

export const updateTextValues = (newValues) => {
  textValues = { ...textValues, ...newValues };
};

export const setLayoutData = (data) => {
  layoutData = data;
};

export const setCurrentPageSize = (pageSize) => {
  currentPageSize = pageSize;
};
